import {
  Col,
  Row,
  Form,
  Breadcrumb,
  Switch,
  Input,
  Select,
  Tabs,
  DatePicker,
} from "antd";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AddEditButton from "../UI/AddEditButton/addeditbutton";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import TextArea from "../UI/InputNumberComponent/TextArea";
import { InputNumber } from "../UI/InputNumberComponent/inputnumber";
import { getSupplierDropdown } from "../../api/supplier";
import { useMutation } from "react-query";
import { getBillsDropdown } from "../../api/bills";
import { getCurrencyDropdown } from "../../api/currency";

function AddEditReturn() {
  const { state } = useLocation();
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const [form] = Form.useForm();
  const [key, setKey] = useState("1");
  const [selectedSupplier, setSelectedSupplier] = useState<number>(
    state?.supplier?.id
  );
  const [selectedCurrency, setSelectedCurrency] = useState<number>(
    state?.currency?.id
  );
  const [suppliers, setSuppliers] = useState<
    {
      value: number;
      option: string;
    }[]
  >();
  const [currencies, setCurrencies] = useState<
  {
    value: number;
    option: string;
  }[]
>();
  const [bills, setBills] = useState<
    {
      value: number;
      option: string;
    }[]
  >();
  const isEdit = () => {
    return !!id;
  };
  const onChange = (key: string) => {
    setKey(key);
  };

  const items = [
    {
      key: "1",
      label: `${t("general-information")}`,
    },
  ];
  const [inputEnabled, setInputEnabled] = useState(false);
  const handleRadioChange = (checked: any) => {
    setInputEnabled(checked);
  };

  const { mutateAsync: getSupplierMutation } = useMutation(
    "supppliers",
    getSupplierDropdown,
    {
      onSuccess: (res) => {
        setSuppliers(
          res.data.map((supplier: any) => {
            return {
              value: supplier.id,
              label: supplier.name,
            };
          })
        );
      },
    }
  );
  const { mutateAsync: getBillsMutation } = useMutation(
    "supppliers",
    (id: number) => getBillsDropdown(id),
    {
      onSuccess: (res) => {
        setBills(
          res.data.map((bill: any) => {
            return {
              value: bill.id,
              label: bill.invoiceNo,
            };
          })
        );
      },
    }
  );

  const { mutateAsync: getCurrencyMutation } = useMutation(
    "currency",
    getCurrencyDropdown,
    {
      onSuccess: (res) => {
        setCurrencies(
          res.data.map((currency: any) => {
            return {
              value: currency.id,
              label: currency.name,
            };
          })
        );
      },
    }
  );

  useEffect(() => {
    getSupplierMutation();
    getCurrencyMutation()
  }, []);
  useEffect(() => {
    selectedSupplier && getBillsMutation(selectedSupplier);
  }, [selectedSupplier]);

  return (
    <>
      <Row>
        <Col
          offset={1}
          span={20}
          style={{
            marginBottom: "10px",
          }}
        >
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("purchases")}</>,
              },
              {
                title: <Link to="/return">{t("returns-list")}</Link>,
              },
              {
                title: (
                  <>
                    {" "}
                    {isEdit()
                      ? `${t("edit-returns-bill")}`
                      : `${t("add-returns-bill")}`}
                  </>
                ),
              },
              {
                title: (
                  <>
                    <span className="breadcrumbcolor">
                      {t("general-information")}
                    </span>
                  </>
                ),
              },
            ]}
          />
        </Col>

        {isEdit() ? (
          <Col offset={1} span={20} className="editTitle">
            {"id"}
          </Col>
        ) : (
          <Col offset={1} span={20} className="editTitle">
            {t("add-returns-bill")}
          </Col>
        )}
      </Row>
      <Col offset={1} span={22}>
        <Tabs
          className="ant-tab"
          defaultActiveKey="1"
          activeKey={key}
          items={items}
          onChange={onChange}
        />
      </Col>

      <Col offset={1} span={22}>
        <Form layout="vertical" form={form} id="ReturnForm">
          <Row style={{ minHeight: "55vh" }}>
            <Col span={6}>
              <Form.Item
                name="supplierId"
                label={`${t("supplier")}`}
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={selectedSupplier}
              >
                <Select
                  placeholder={`${t("select-supplier")}`}
                  options={suppliers}
                  onChange={(value) => {
                    setSelectedSupplier(value);
                  }}
                />
              </Form.Item>

              <Form.Item
                name="billId"
                label={`${t("bill-id")}`}
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={state?.id}
              >
                <Select placeholder={`${t("select-bill")}`} options={bills} />
              </Form.Item>

              <Form.Item
                name="date"
                label={`${t("date")}`}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  placeholder={`${t("MM/DD/YYYY")}`}
                  style={{ width: "100%" }}
                />
              </Form.Item>

              <Form.Item
                name="currId"
                label={`${t("currency")}`}
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={selectedCurrency}
              >
                <Select placeholder={`${t("select-currency")}`} options={currencies}/>
              </Form.Item>
            </Col>

            <Col offset={2} span={6}>
              <Form.Item
                name="exchangerate"
                label={`${t("exchange-rate")}`}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <InputNumber maxLength={10} />
              </Form.Item>

              <Form.Item label={`${t("taxable")}`}>
                <Switch
                  checkedChildren={`${t("yes")}`}
                  unCheckedChildren={`${t("no")}`}
                  onChange={handleRadioChange}
                />
              </Form.Item>

              <Form.Item
                rules={[
                  {
                    required: inputEnabled,
                  },
                ]}
                name="taxExchangeRate"
                label={`${t("tax-exchange-rate")}`}
              >
                <Input
                  autoComplete="off"
                  placeholder={`${t("enter-text")}`}
                  maxLength={10}
                  data-testid="tax"
                  disabled={!inputEnabled}
                />
              </Form.Item>
            </Col>

            <Col offset={2} span={6}>
              <Form.Item name="notes" label={`${t("notes")}`}>
                <TextArea maxLength={500} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>

      <Row>
        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <AddEditButton
            data-testid="add-button"
            disabled={""}
            onClick={() => {
              setOpen(true);
            }}
            isLoading={""}
          />
        </Col>
      </Row>
      <AddEditModal
        form="ReturnForm"
        open={open}
        setOpen={setOpen}
        name={<span> {""}</span>}
        title={`${t("modal-return")}`}
      />
    </>
  );
}

export default AddEditReturn;
